import { render, staticRenderFns } from "./Trademark.vue?vue&type=template&id=fdbe412e"
import script from "./Trademark.vue?vue&type=script&lang=js"
export * from "./Trademark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports